module.exports = __webpack_public_path__ + "img/BlinkArt_Axe2H_Medium.63b1300b.png";